import {Redirect} from "expo-router";
import {PropsWithChildren} from "react";
import {useAuth} from "@/auth/useAuth";

export function Authenticated({children}: PropsWithChildren) {
    const {isAuthenticated, isLoading} = useAuth();

    if (isLoading) {
        return null;
    }

    if (!isAuthenticated) {
        return <Redirect href={'/login'} />;
    }

    return <>{children}</>;
}
